
import { Vue, Component } from 'vue-property-decorator';
import T from '../../../lang';

@Component
export default class LibinteractiveDownload extends Vue {
  get zipUrl(): string {
    return '/problem/libinteractive/files.zip';
  }

  T = T;
}
